<template>
  <div class="PtownConsvComm">

    <h3 class="bucket-title">March 5, 2019 &mdash; Provincetown Conservation Committee Hearing</h3>

    <div name="ConCon20191217Video2" class="videoPlayer">
      <video ref="ConCon20190305Video2" id="ConCon20190305Video2" width="100%" height="100%" controls>
        <source src="@/assets/videos/PtownConCommHearing20190305_2.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>

    <!-- <h3>Highlights</h3> -->
    <button class="btn btn-primary" @click="queueUpAndPlay(0, 16, 'ConCon20190305Video2')" type="button">Conservation
      Agent discucssing the <i>Conservation Restriction</i> on 72 West Vine Street</button>
    <!-- <p><button class="btn btn-secondary playPause" @click="playPause('ConCon20190305Video2')"
        type="button">Play/Pause</button>
    </p> -->


    <div>
      <h4><a href="#" @click="queueUpAndPlay(0, 16, 'ConCon20190305Video2')">Tim Famulare, <i>Provincetown
            Conservation Agent</i> </a>
      </h4>
      <p>
        (3:33:15) One thing that did raise a point that I think was not addressed in the <i>Notice of Intent</i> and
        that is there is a <b><i>Conservation Restriction</i></b> on a part of this property that was imposed
        back when this area was mapped as Natural Heritage, and endangered species, land
        and it's basically in the corner of the property where the current horse paddock is.
        The applicant is working with the, that area is no longer, shown as, mapped
        as designated endangered species habitat, but the restriction still stays in place,
        but the applicant has been working with the Division of Fisheries and Wildlife to
        relocate that restriction to an area that would be more appropriate for the species that,
        was listed in that area. (Whispering), I think that's all I have. (3:34:05)
      </p>

      <button class="btn btn-secondary playPause" onclick="playPause('ConCon20190305Video2')"
        type="button">Play/Pause</button>
    </div>

    <div>
      <h3 class="bucket-title">December 17, 2019 &mdash; Provincetown Conservation Committee Hearing</h3>
      <!-- <h5>December 17, 2019</h5> -->
      <div name="ConCon20191217Video1" class="videoPlayer">
        <video ref="ConCon20191217Video1" id="ConCon20191217Video1" width="100%" height="100%" controls>
          <source src="@/assets/videos/PtownConCommHearing20191217_1.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <i><b>Christopher King, Atlantic Design Engineering, Inc.</b></i> Sure, yeah, uh, in the interest of being as concise as I can, but still doing my client justice, I’ve heard several recurring themes through those particularly the opposition letters. Ya know, one of the most prominent themes was that I was told that you could never build on this or it was a single family house only, 
              or umm it looks beautiful when I walk my dog or a cacophony of peepers. Quite frankly the wetland is not there particularly for human enjoyment, that’s not the value that we're tasked with protecting. I know it's one of the interests of the act, but I don't think it's an aesthetics interest, I think it comes more to recreability and fishability, ummmm, so, you know to my knowledge, and Mr. Krohn can certainly correct me if I'm wrong, which I don't think I am, but
              there's no deed restriction that limits Mr. Krohn to what he can and cannot build on his lot. Everyone has that right, ummm, there is also some question regarding the relocation of the easement itself, ummm, you know again, this was championed my Mr. Krohn once he realized the mapping was changed, the mapping, ya know, you don't just move an easement, um, and notify the toads...ya know,  Natural Heritage comes out, they do specific studies, they evaluate the habitat, the current extent of the habitat and depending on the amount of development occurring in some areas may actually change the limit of that habitat as it's mapped, and that's what happened, ah, that wasn't a result of Mr. Krohn's activities, umm, that was a result of development in the area just altering the edge of the protected species. The protected species is exactly why the Conservation Easement was created, not only on Mr. Krohn's lot but on the adjacent lots, ummm, at the time that the mapping was changed Mr. Krohn did just about what any landowner probably would do was ask well do I still need this easement, 
              and in contact with Natural Heritage again, the regulatory body for these areas and the review of these areas through the MESA process whether it's a take or a non-take, deem that you know what, this are is no longer valuable to the toads based on where we map and what we observe in this area and we think that it will be better served over here, ah, so it wasn't just a willy nilly swap to maximize development, 
              it was a question I think that any landowner would ask and again quite frankly it's a question that the remaining properties under that easement under covenant that's being referenced may want to ask themselves because maybe they will have an opportunity to open up a portion of their lot that was previously not developed, ummm, but again that's getting a little bit outside of what we're tasked with this evening, it's not whether or not it’s an agricultural exemption, that seemed to be another, umm recurring theme, ummm, throughout the letters, ummm, it’s not whether, ya know the validity of the, the, 
              the conservation easement umm changing locations because it has, it's been recorded, the information has been provided to the Commission, and Mr Krohn has gone through the proper regulatory channels to the, ya know, 
              to the best of my knowledge, that was before my time, but my understanding is that all of that’s been documented, and, ummm, if if the Commission would like more documentation, ya know, I am sure Mr Krohn could provide that, but um ya know, I think that ya know, considering the fact that this development is in a previously disturbed area it's completely being utilized right now, umm we're not changing the ground cover, umm we're not doing mass clearing to build huge overt towering condominium developments right up against the edge of the buffer zone, ah, we’re really working within the footprint that was previously disturbed and working within the regulations that are set forth with the different Boards in the Town complying with all of them, quite frankly, ummm, doing what Mr. Krohn feels, that ya know, what he wants to do, it’s his land and, and that’s his right. Um and I’ll, ya know I’ll close it at that. I know there are other issues that we could certainly speak to, but again, if there’s anything the Commission has specific questions on or its concerned about. I just appreciate the opportunity to, ah, respond and with that I turn it over to you folks.
      </div>
      <button class="btn btn-primary" @click="queueUpAndPlay(4, 30, 'ConCon20191217Video1')" type="button">Tim
        Falumare</button>
      <p>
        I would just add that, umm, I did want to confirm, yes, this whole area was previously designated by
        the
        State as habitat for the Eastern Spadefoot Toad, those maps were revised in August of 2017 to remove
        this area as designated habitat. Umm, and ah,
        <a href="#ConCon20191217Video1" @click="queueUpAndPlay(4, 48, 'ConCon20191217Video1')">the easement area
          restriction was
          between the State’s
          Division of Fisheries and Wildlife and the property owner, not the Conservation Commission was not
          involved with that.</a>
      </p>

      <button class="btn btn-secondary playPause" onclick="playPause('ConCon20191217Video1')"
        type="button">Play/Pause</button>
    </div>

  </div>

  </div>
</template>

<script>

  export default {
    data() {
      return {
        somedataelement: ''
      }
    },
    components: {

    },
    computed: {
      someFunction() {
        return 'someFunction'
      },
    },
    watch: {
      someWatchThing(value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },
    methods: {
      greet: function (event) {
        // `this` inside methods points to the Vue instance
        alert('Hello ' + this.name + '!')
        // `event` is the native DOM event
        if (event) {
          alert(event.target.tagName)
        }
      },

      queueUpAndPlay: function (min, sec, vidName) {
        var vid = this.$refs[vidName];

        let startTime = (min * 60) + sec;
        vid.currentTime = startTime;
        if (vid.paused) vid.play();
      },

      playPause: function (vidName) {
        var vid = this.$refs[vidName];
        if (vid.paused)
          vid.play();
        else
          vid.pause();
      }
    }
  }
</script>

<style scoped>
  .videoPlayer {
    width: 340px;
    height: auto;
  }

  .playPause {
    margin-top: 1rem;
  }
</style>